export interface IRemoveItemOptions {
  onlyItemsIfEntity?: boolean;
  update?: boolean;
  silent?: boolean;
}

export const RemoveItemDefaultOptions: IRemoveItemOptions = {
  onlyItemsIfEntity: false,
  silent: false,
  update: true
} as const;
